<!--
 * @Description: 步骤条
 * @Autor: lwq
 * @Date: 2020-07-01 18:47:28
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-17 14:49:25
--> 
<template>
  <div class="step">
    <v-stepper v-model="stepIndex">
      <v-stepper-header>
        <div v-for="(item,index) in list"
             :key='index'
             class="everyStep"
             :class="{'lastStep': index == list.length-1}">
          <v-stepper-step color="primary"
                          :complete="stepIndex > index+1"
                          :step="index+1">{{item.name}}</v-stepper-step>
          <v-divider v-if="index != list.length-1"></v-divider>
        </div>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content class="pa-0"
                           v-for="(item,index) in list"
                           :key='index'
                           :step="index + 1">
          <slot :name='index+1'></slot>

        </v-stepper-content>

      </v-stepper-items>
    </v-stepper>
  </div>
</template>
<script>
/**
 * @description: 参数说明
 * @param {list}  
 * list: [
          {
              name: '第一步'
          },
          {
              name: '第二步'
          },
          {
              name: '第三步'
          }
      ]
 * <slot :name='index+1'></slot> 这是插槽，每个步骤里面的内容 
 * 用法  
 *   <mrc_ess_myStep :list='list'>
          <template v-slot:index+1> index+1 这是代表第几个步骤的内容
              这里面写内容
          </template>
      </mrc_ess_myStep>

 * @event change stepIndex 改变事件
 * @author: lwq
 */
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    stepIndex: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      // stepIndex: 1
    }
  },
  model: {
    prop: 'stepIndex',
    event: 'change'
  },
  methods: {
  },
  watch: {
    stepIndex (val) {
      this.$emit('change', val)
    }
  }
}
</script>
<style scoped>
.step /deep/ .v-stepper,
.step /deep/ .v-stepper__header {
  box-shadow: none;
}
.step /deep/ .v-stepper__header {
  height: 60px;
  background-color: #eeeef0;
  /* padding: 14px; */
}
.step /deep/ .v-stepper__header .v-divider {
  margin: 0;
}
.everyStep {
  flex: 1;
  display: flex;
  align-items: center;
}
.lastStep {
  flex: none;
}
</style>